import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { theme } from '../theme'; // Import your theme

const StyledLink = styled(RouterLink)((props) => {
  const { color = 'default', underline = 'none', size = 'md', sx = {} } = props;

  // Extract color from theme based on the specified color variant
  const colorValue = theme.colors[color]?.main || theme.colors.default.main;

  // Set default textDecoration
  const defaultTextDecoration = underline === 'always' ? 'underline' : 'none';

  return {
    color: colorValue,
    textDecoration: defaultTextDecoration,
    fontSize: size === 'sm' ? '0.875rem' : size === 'lg' ? '1.5rem' : '1rem',
    transition: 'text-decoration 0.2s ease', // Smooth transition for hover
    '&:hover': {
      textDecoration: underline === 'hover' ? 'underline' : defaultTextDecoration,
    },
    ...sx,
  };
});

export const Link = ({ to, children, color, underline, size, className, sx }) => {
  return (
    <StyledLink to={to} color={color} underline={underline} size={size} className={className} sx={sx}>
      {children}
    </StyledLink>
  );
};

// PropTypes for the Link component
Link.propTypes = {
  /** The URL to navigate to */
  to: PropTypes.string.isRequired,
  /** Link text */
  children: PropTypes.node.isRequired,
  /** Color of the link */
  color: PropTypes.oneOf(Object.keys(theme.colors)), // Use keys of colors in the theme
  /** Underline style */
  underline: PropTypes.oneOf(['none', 'hover', 'always']),
  /** Size of the link text */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Additional CSS class name for custom styling */
  className: PropTypes.string,
  /** Custom styles using sx prop */
  sx: PropTypes.object,
};

// Default props for Link component
Link.defaultProps = {
  color: 'secondary',
  underline: 'none',
  size: 'md',
  sx: {},
};
